let domainAnalysisComplete = false;
let webAppProtocol = "";
let webAppSubdomain = "";
let truncatedHostname = "";
let webAppPort = "";

const domainAnalysis = (): void => {
  if (domainAnalysisComplete === false) {
    const {
      protocol: INITIAL_PROTOCOL,
      hostname: INITIAL_HOSTNAME,
      port: INITIAL_PORT,
    } = window.location;
    webAppProtocol = INITIAL_PROTOCOL;
    webAppPort = INITIAL_PORT;
    const hostnameComponents = INITIAL_HOSTNAME.split(".");
    const numHostnameComponents = hostnameComponents.length;
    let siteWasAccessedThroughSubdomain = false;
    if (numHostnameComponents > 3) {
      siteWasAccessedThroughSubdomain = true;
    }

    // The base namespace is the registrable domain (mymomento.com). A regional label such as
    // "uk" sitting directly above it (…uk.mymomento.com) is part of the base — so a regional
    // stack host like operator.uk.mymomento.com must resolve to *itself* (base = full host, no
    // team subdomain) rather than truncating "operator" away and mis-building the hosted-UI
    // redirect_uri to https://uk.mymomento.com/ (which isn't a registered callback →
    // redirect_mismatch). US hosts (≤3 parts) are unaffected: baseComponentCount stays 3.
    const REGION_SEGMENTS = ["uk"];
    const hasRegionSegment = numHostnameComponents >= 4
      && REGION_SEGMENTS.includes(hostnameComponents[numHostnameComponents - 3]);
    const baseComponentCount = hasRegionSegment ? 4 : 3;

    webAppSubdomain = "";
    truncatedHostname = "";
    for (let i = 0; i < (numHostnameComponents - baseComponentCount); i += 1) {
      webAppSubdomain = `${webAppSubdomain}${(i === 0) ? "" : "."}${hostnameComponents[i]}`;
    }
    for (let i = (numHostnameComponents - baseComponentCount); i < numHostnameComponents; i += 1) {
      truncatedHostname = `${truncatedHostname}${(i === (numHostnameComponents - baseComponentCount)) ? "" : "."}${hostnameComponents[i]}`;
    }

    // sub.domain.tld (e.g. ravens.mymomento.com) — the loop above only runs when length > 3,
    // so three-part hosts left webAppSubdomain empty and team-specific UI never activated.
    if (numHostnameComponents === 3) {
      webAppSubdomain = hostnameComponents[0];
    }

    domainAnalysisComplete = true;
  }
};

export const WebAppProtocol = (): string => {
  domainAnalysis();
  return webAppProtocol;
};

export const WebAppSubdomain = (): string => {
  domainAnalysis();
  return webAppSubdomain;
};

export const TruncatedHostname = (): string => {
  domainAnalysis();
  return truncatedHostname;
};

export const WebAppPort = (): string => {
  domainAnalysis();
  return webAppPort;
};

export const getCurrentTeamName = (): string => {
  return WebAppSubdomain() || "";
  // return "Kraken";
};

/** True on UK/EU regional operator hosts (e.g. operator.uk.mymomento.com). */
export const isUkRegionalOperatorHost = (): boolean => {
  const host = String(window.location.hostname || "").toLowerCase();
  const parts = host.split(".").filter(Boolean);
  if (parts.includes("uk")) return true;
  return host.includes(".uk.");
};

/** Location parent label: Country on UK/EU stacks, State elsewhere. */
export const locationRegionFieldLabel = (): "Country" | "State" => (
  isUkRegionalOperatorHost() ? "Country" : "State"
);
